import { FC, memo, ReactNode } from 'react';
import { Typography, TypographyProps } from '@mui/material';

import { TMoplaColors, TMoplaColorsV2 } from '@mopla/mui';

import { IRootProps, Root } from './IconMessage.styles';

interface IInfoMessageProps {
	className?: string;
	icon?: ReactNode;
	message: string;
	color?: TMoplaColors | TMoplaColorsV2;
	variant?: TypographyProps['variant'];
	testId?: string;
	type?: IRootProps['type'];
	footer?: ReactNode;
}

export const IconMessage: FC<IInfoMessageProps> = memo(
	({
		className,
		icon,
		message,
		color = 'neutral.80',
		variant = 'caption',
		testId = 'iconMessage',
		type,
		footer,
	}) => {
		return (
			<Root
				ownerState={{ type, color }}
				className={className}
				data-testid={testId}
			>
				{icon && <div className="iconWrapper">{icon}</div>}
				<Typography className="label" variant={variant} color="inherit">
					{message}
				</Typography>
				{footer && <div className="footer">{footer}</div>}
			</Root>
		);
	}
);
